import {useEffect, useState} from "react";
import {findGoogleReviewRequestsWithPagination} from "../api/googleReviewApiClient";

export const useGoogleReviewRequests = (page, pageSize, filterEmail, filterCustomerName, filterReviewGiven, reloadTrigger) => {
    const [googleReviewRequests, setGoogleReviewRequests] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const googleReviewRequestsWithPagination = findGoogleReviewRequestsWithPagination(
            page,
            pageSize,
            filterEmail,
            filterCustomerName,
            filterReviewGiven,
            abortController.signal
        );

        googleReviewRequestsWithPagination
            .then(
                (data) => {
                    const googleReviewRequests = data.googleReviewRequests;
                    const pagination = data.pagination;

                    setGoogleReviewRequests(googleReviewRequests)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, filterEmail, filterCustomerName, filterReviewGiven, reloadTrigger]);

    return {googleReviewRequests : googleReviewRequests, pagination};
};
